import * as React from 'react';
import { useSelector } from 'react-redux';
import { ParallelLoad, selectUser, UneditableReference, useCacheRecord } from 'gossamer-front-end';
import { UserView } from 'cb-model';

interface UneditableReferenceProps {
  value: string;
}

export const UneditableReferenceUser: React.FC<UneditableReferenceProps> = (props) => {
  const record = useCacheRecord(UserView, props.value, !props.value);
  const user = useSelector(selectUser);
  if (!user.roleId) {
    return null; // spinner
  }
  if (user.roleId === 'user') {
    const label = record.data
      ? [record.data.first_name, record.data.last_name, '[' + record.data.email + ']'].join(' ')
      : null;
    return (
      <ParallelLoad responses={[record]}>
        <span>{label}</span>
      </ParallelLoad>
    );
  }
  return <UneditableReference refEntity={UserView} suppressLink={false} value={props.value} />;
};
